// extracted by mini-css-extract-plugin
module.exports = {"container":"_3Va22HBfoU24UhXged-XTw"};